import { createSelector } from 'reselect';
import { getAreActivitiesEnabled } from 'lib/selectors/getAreActivitiesEnabled';
import { getLatestActivity } from 'lib/selectors/getLatestActivity';
import { getCurrentLaborTicket } from 'lib/selectors/getLaborTickets';
import { getPostLaborUpdatesOnNats } from 'lib/selectors/getPostLaborUpdatesOnNats';

const getHasOpenActivity = createSelector(
  [
    getAreActivitiesEnabled,
    getLatestActivity,
    getCurrentLaborTicket,
    getPostLaborUpdatesOnNats,
  ],
  (
    areActivitiesEnabled,
    latestActivity,
    currentLaborTicket,
    natsFlowEnabled
  ) => {
    // Async flow: labor ticket determines if there's an open activity
    // Activity is ONLY open if there's an OPEN labor ticket (operator actively working)
    if (natsFlowEnabled && areActivitiesEnabled) {
      return currentLaborTicket?.state === 'OPEN';
    }

    // Standard flow: check actual activity
    return !!(
      areActivitiesEnabled &&
      latestActivity &&
      latestActivity.end === null
    );
  }
);

export { getHasOpenActivity };
